import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import IMG from '../IMG/VLAD.jpeg'

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [text, setText] = useState('');
  const [textarea, setTextarea] = useState('');
  const formRef = useRef();

  const sendEmail = () => {

    emailjs.send('service_bjpgkqi', 'template_qjfh8yw', {
      to_name: `${name}`,
      to_email: `${email}`,
      number: `${number}`,
      subject: `${text}`,
      message: `${textarea}`,
    }, 'ZKDb-KTJxDluMblPe')
      .then(
        (response) => {
          console.log('Email sent:', response);
          Swal.fire({
            title: 'Success!',
            text: 'Email Sent Successfully!',
            icon: 'success',
          });
        },
        (error) => {
          console.error('Email send failed:', error);
          Swal.fire({
            title: 'Error!',
            text: 'Failed to send email',
            icon: 'error',
          });
        }
      );

    // Clear the form fields after sending the email
    setName('');
    setEmail('');
    setNumber('');
    setText('');
    setTextarea('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid email address',
        icon: 'error',
      });
      return;
    }
    sendEmail();
  };

  // Function to validate email
  const validateEmail = (email) => {
    // Regular expression for email validation
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleKeyDown = (e) => {
    // Check if the Enter key is pressed (key code 13)
    if (e.keyCode === 13) {
      handleSubmit(e);
    }
  };

  return (
    <>
      <div className="Contact2">
        <div className="container pt-32 text-center">
          <h1 className='uppercase text-5xl font-bold'>Contact<span>.</span></h1>
        </div>
      <div className="container Goggle_Map pt-10" data-aos="zoom-in">
        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3449.2471122035035!2d71.47373357136594!3d30.17293429364736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzDCsDEwJzMwLjgiTiA3McKwMjgnMDguMiJF!5e0!3m2!1sen!2s!4v1709396966222!5m2!1sen!2s" title='MyLocation' className='w-full h-[500px]' style={{ border: '0' }} loading="lazy"></iframe>
      </div>
      <div className="InfoContact sm:grid sm:grid-cols-2 text-center">
        <div className="card py-10">
          <img src={IMG} alt="" className='rounded-full select-none max-w-80 mx-auto' data-aos="zoom-in"/>
          <h1 className="text-3xl font-semibold py-6" data-aos="zoom-in">Noman Ansari<span>.</span></h1>
          <p className="py-3 leading-7 tracking-wider text-justify w-10/12 mx-auto" data-aos="zoom-in">Hi I'm Noman Ansari If You want to Contact with us Please Input the required Details and than's your mail will be Send to Our Account <a href="https://mail.google.com/mail/?view=cm&fs=1&to=nomanansarrii17@gmail.com&body=Hello!%20I%20want%20to%20hire%20you." target='_blank' rel="noreferrer" className='underline'><span>nomanansarrii17@gmail.com</span></a> Thank You to Contact Us <span>.🌹</span></p>
        </div>
        <div id="Contact2" className='py-6'>
          <section>
            <form id="form2" ref={formRef} action="/" onSubmit={handleSubmit} onKeyDown={handleKeyDown} data-aos="zoom-in">
              <div className="input-box2">
                <div className="input-field2" data-aos="zoom-in-up">
                  <input
                    type="text"
                    name="Name"
                    id="name"
                    placeholder="Full Name"
                    required
                    value={name}
                    autoComplete='off'
                    className='w-[90%] mx-auto'
                    onChange={(e) => setName(e.target.value)}
                  />
                  <span className='foucs'></span>
                </div>
                <div className="input-field2" data-aos="zoom-in-up">
                  <input
                    type="email"
                    name="Email"
                    id="email"
                    placeholder="Email Address"
                    required
                    value={email}
                    autoComplete='off'
                    className='w-[90%] mx-auto'
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <span className='foucs'></span>
                </div>
              </div>
              <div className="input-box2">
                <div className="input-field2" data-aos="zoom-in-up">
                  <input
                    type="number"
                    name="Number"
                    id="number"
                    placeholder="Phone Number"
                    required
                    className='w-[90%] mx-auto'
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                  />
                  <span className='foucs'></span>
                </div>
                <div className="input-field2" data-aos="zoom-in-up">
                  <input
                    type="text"
                    name="Text"
                    id="text"
                    placeholder="Email Subject"
                    required
                    value={text}
                    autoComplete='off'
                    className='w-[90%] mx-auto'
                    onChange={(e) => setText(e.target.value)}
                  />
                  <span className='foucs'></span>
                </div>
              </div>
              <div className="textarea-field2" data-aos="zoom-in-up">
                <textarea
                  name="Textarea"
                  id="textarea"
                  cols="60"
                  rows="10"
                  placeholder="Your Message"
                  required
                  value={textarea}
                  onChange={(e) => setTextarea(e.target.value)}
                ></textarea>
                <span className='foucs'></span>
              </div>
              <button data-aos="zoom-in" type="submit" className="btn4 font-normal py-2 px-5 mt-10">Send Message</button>
            </form>
          </section>
        </div>
      </div>
      </div>
    </>
  );
}

export default Contact;
